import(/* webpackMode: "eager", webpackExports: ["ParishFlowLayoutClient"] */ "/home/runner/work/ark/ark/@apps/web/src/app/[locale]/parish/(flow)/ParishFlowLayoutClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["usePathname"] */ "/home/runner/work/ark/ark/@i18n/next/src/hooks/usePathname.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useSetLocale"] */ "/home/runner/work/ark/ark/@i18n/next/src/hooks/useSetLocale.ts");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/home/runner/work/ark/ark/@i18n/next/src/providers/I18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nMessage"] */ "/home/runner/work/ark/ark/@i18n/react/src/app/I18nMessage.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useTranslations"] */ "/home/runner/work/ark/ark/@i18n/react/src/app/useTranslations.ts");
;
import(/* webpackMode: "eager", webpackExports: ["I18nMessage"] */ "/home/runner/work/ark/ark/@i18n/react/src/components/I18nMessage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useDateFormatter"] */ "/home/runner/work/ark/ark/@i18n/react/src/hooks/useDateFormatter.ts");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/home/runner/work/ark/ark/@i18n/react/src/providers/I18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntlErrorCode","useFormatter","useLocale","useNow","useTranslations"] */ "/home/runner/work/ark/ark/@i18n/react/src/useIntl.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ark/ark/node_modules/.pnpm/next-intl@4.13.0_@swc+helpers@0.5.23_next@16.3.3_@opentelemetry+api@1.9.0_@playwright+test@1._spfkh7mcz36o7nnjzv2uv3hurm/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
